"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTokenAuthHeader = void 0;
function generateTokenAuthHeader(token) {
    return "".concat(token.token_type, " ").concat(token.access_token);
}
exports.generateTokenAuthHeader = generateTokenAuthHeader;
